export const GET_RESOURCES_DATA = 'resources/GET_RESOURCES_DATA';